import { h } from 'preact'
import classNames from 'classnames'

interface Props {
  onPress: () => void
  disabled?: boolean
}

export function PreviousMonthButton({ onPress, disabled }: Props) {
  return (
    <button
      disabled={disabled}
      onClick={onPress}
      type="button"
      class="btn-icon-ghost"
    >
      <svg
        class="inline-flex w-5 h-5"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M15 19l-7-7 7-7"
        />
      </svg>
    </button>
  )
}
